<template>
    <v-dialog v-bind="$attrs" persistent content-class="modal-dialog">
        <div class="modal-message">
            <div class="common-text mb-2">
                Смена пароля
            </div>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                class="auth-form"
                @submit.prevent
            >
                <div class="main-text mb-5 text-center">
                    <div class="auth-form__input mb-4">
                        <label for="password" class="main-text"> Новый пароль </label>
                        <v-text-field
                            v-model="password"
                            id="password"
                            :rules="[rules.required]"
                            :type="showPassword ? 'text' : 'password'"
                            placeholder="Введите пароль"
                            class="dark-input ma-0"
                            dense
                            @change="valid = true"
                            @input="valid = true"
                        >
                            <template v-slot:append>
                                <div
                                    v-if="showPassword"
                                    v-html="require('!html-loader!@/assets/icons/eye_icon.svg')"
                                    class="img-form"
                                    @click="showPassword = !showPassword"
                                />
                                <div
                                    v-else
                                    v-html="require('!html-loader!@/assets/icons/eye_closed_icon.svg')"
                                    class="img-form"
                                    @click="showPassword = !showPassword"
                                />
                            </template>
                        </v-text-field>
                    </div>
                    <div class="auth-form__input mb-60">
                        <label for="confirmPassword" class="main-text"> Подтверждение пароля </label>
                        <v-text-field
                            v-model="confirmPassword"
                            id="confirmPassword"
                            :rules="[rules.required]"
                            :type="showConfirmPassword ? 'text' : 'password'"
                            placeholder="Введите пароль ещё раз"
                            class="dark-input ma-0"
                            dense
                            @change="valid = true"
                            @input="valid = true"
                        >
                            <template v-slot:append>
                                <div
                                    v-if="showConfirmPassword"
                                    v-html="require('!html-loader!@/assets/icons/eye_icon.svg')"
                                    class="img-form"
                                    @click="showConfirmPassword = !showConfirmPassword"
                                />
                                <div
                                    v-else
                                    v-html="require('!html-loader!@/assets/icons/eye_closed_icon.svg')"
                                    class="img-form"
                                    @click="showConfirmPassword = !showConfirmPassword"
                                />
                            </template>
                        </v-text-field>
                    </div>
                </div>
                <v-flex class="d-flex w-100 justify-center mt-3">
                    <v-btn class="btn-dark main-text" @click="close">
                        Отменить
                    </v-btn>
                    <v-btn
                        :disabled="!valid || !(password && confirmPassword)"
                        type="submit"
                        class="yellow-btn small-btn main-text"
                        @click="validate"
                    >
                        Сохранить
                    </v-btn>
                </v-flex>
            </v-form>
            <ModalMessage
                v-model="openErrorMessage"
                title="Пароли не совпадают"
                text="Проверьте правильность ввода и повторите попытку"
                text-btn="Хорошо"
                text-center
            />
        </div>
    </v-dialog>
</template>

<script>
import ModalMessage from "@/components/modals/ModalMessage";
export default {
    name: "ModalChangePassword",
    components: {ModalMessage},
    props: {
        user: {
            type: String,
        },
    },
    data() {
        return {
            password: null,
            confirmPassword: null,
            valid: true,
            showPassword: false,
            showConfirmPassword: false,
            rules: {
                required: value => !!value || 'Обязательное поле',
            },
            openErrorMessage: false,
        };
    },
    methods: {
        close() {
            this.$emit('input', false);
        },
        validate() {
            this.valid = this.$refs.form.validate();
            if (this.password != this.confirmPassword) {
                this.valid = false;
                this.openErrorMessage = true;
                return;
            }
            if (this.valid) {
                this.changePassword();
            }
        },
        changePassword() {
            this.$http.patch('/users/' + this.user + '/', {
                password: this.password,
            })
                .then(() => {
                    this.close();
                });
        },
    }
}
</script>

<style lang="scss" scoped>
.modal-message {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.btn-dark.v-btn {
    max-width: 107px;
}

.yellow-btn.small-btn.v-btn {
    width: auto;
    min-width: 105px;
    max-height: 42px;
    min-height: 42px;
    margin-left: 8px;
}
</style>